import { Delete } from "@mui/icons-material"
import { Autocomplete, IconButton, TextField, Tooltip } from "@mui/material"
import { useEffect, useState } from "react";
import Swal from 'sweetalert2'

export default function AddSubjects({formik}) {
    const [errorFirstName, setErrorFirstName] = useState('');
    const [errorLastName, setErrorLastName] = useState('');
    const [errorEmail, setErrorEmail] = useState('');
    const [errorPP, setErrorPP] = useState('');

    const removeSubject = (index) => {
        let updatedList = [...formik.values.subjects];
        updatedList.splice(index, 1);
        formik.setFieldValue('subjects', updatedList);
    };

    useEffect(() => {        
        formik.submitForm()
    }, [formik.values.subjects])

    const normalizeString = (value) => {
        if (!value) return '';
        return value.trim().replace(/\s+/g, ' ');
    };

    const addSubject = async () => {
        const firstName = normalizeString(formik.values.subjectFirstName);
        const lastName = normalizeString(formik.values.subjectLastName);
        const title = normalizeString(formik.values.subjectTitle);
        if(title != ''){
            Swal.fire({
                icon: 'warning',
                title: 'Warning!',
                text: 'If you enter a Title, it will replace the Subject Name throughout the report (except on the first page) and in the Rater Assessment.',
                confirmButtonText: 'OK',
                confirmButtonColor: '#f8bb86'
            });
        }
        if(firstName === ''){
            setErrorFirstName('First Name is required')
        }
        if(lastName === ''){
            setErrorLastName('Last Name is required')
        }
        if(formik.values.subjectEmail === ''){
            setErrorEmail('Email is required')
        }
        if(formik.values.subjectPreferredPronoun === null){
            setErrorPP('Please select')
        }
        if(
            firstName !== '' && 
            lastName !== '' && 
            formik.values.subjectEmail !== '' && 
            formik.values.subjectEmail.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) && 
            formik.values.subjectPreferredPronoun !== ''
        ){
            formik.setFieldValue('subjects', [...formik.values.subjects, {
                id: null,
                firstName: firstName,
                lastName: lastName,
                email: formik.values.subjectEmail,
                preferredPronoun: formik.values.subjectPreferredPronoun.value,
                title: title
            }]);
            formik.setFieldValue('subjectFirstName', '');
            formik.setFieldValue('subjectLastName', '');
            formik.setFieldValue('subjectEmail', '');
            formik.setFieldValue('subjectPreferredPronoun', '');  
            formik.setFieldValue('subjectTitle', '');
        }     
           
    }

    const handleSubjectFirstNameChange = (e) => {
        let value = e.target.value
        formik.setFieldValue('subjectFirstName', value);
        setErrorFirstName('')
    }

    const handleSubjectLastNameChange = (e) => {
        let value = e.target.value
        formik.setFieldValue('subjectLastName', value);
        setErrorLastName('')
    }

    const handleSubjectEmailChange = (e) => {
        let value = e.target.value
        formik.setFieldValue('subjectEmail', value);
        if(value === ''){            
            setErrorEmail('Email is required')
        }
        else{
            setErrorEmail('')
            
        }
    }

    const handleSubjectEmailBlur = (e) => {
        let value = e.target.value
        formik.setFieldValue('subjectEmail', value);
        if(value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)){            
            setErrorEmail('')
        }
        else{
            setErrorEmail('Enter valid email')
        }
    }

    const handleSubjectPPChange = (e, value) => {
        console.log('e',value)
        // let value = e.target.value
        if(value && value.name){
            formik.setFieldValue('subjectPreferredPronoun', value);        
        }
        else{
            formik.setFieldValue('subjectPreferredPronoun', null);
        }
        setErrorPP('')
    }

    return (
        <div className="row py-4">
            <div className="col-md-8 offset-md-2 mt-4">
                <h3 className="heading fs_20">Add Subjects</h3>
                <div className="row d-flex align-items-center mb-3">
                    <div className="col">
                        <div className="mb-3">
                            <label className="form-label" htmlFor="basic-icon-default-name">First Name</label>
                            <div className="input-group input-group-merge">
                                <span id="basic-icon-default-name" className="input-group-text"><i className="bx bx-user"></i></span>
                                <input type="text" name="subjectFirstName" className="form-control" id="basic-icon-default-name" placeholder="First Name" aria-label="Name" aria-describedby="basic-icon-default-fullname2"
                                onChange={handleSubjectFirstNameChange} 
                                onBlur={handleSubjectFirstNameChange}
                                value={formik.values.subjectFirstName}/>
                            </div>
                            <div className="text-danger">{errorFirstName}&nbsp;</div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="mb-3">
                            <label className="form-label" htmlFor="basic-icon-default-name">Last Name</label>
                            <div className="input-group input-group-merge">
                                <span id="basic-icon-default-name" className="input-group-text"><i className="bx bx-user"></i></span>
                                <input type="text" name="subjectLastName" className="form-control" id="basic-icon-default-name" placeholder="Last Name" aria-label="Name" aria-describedby="basic-icon-default-fullname2"
                                onChange={handleSubjectLastNameChange} 
                                onBlur={handleSubjectLastNameChange}
                                value={formik.values.subjectLastName}/>
                            </div>
                            <div className="text-danger">{errorLastName}&nbsp;</div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="mb-3">
                            <label className="form-label" htmlFor="basic-icon-default-email">Email</label>
                            <div className="input-group input-group-merge">
                                <span className="input-group-text"><i className="bx bx-envelope"></i></span>
                                <input type="email" name="subjectEmail" id="basic-icon-default-email" className="form-control" placeholder="Rajiv.doe@example.com" aria-label="Rajiv.doe@example.com" aria-describedby="basic-icon-default-email2" 
                                    onChange={handleSubjectEmailChange} 
                                    onBlur={handleSubjectEmailBlur} 
                                    value={formik.values.subjectEmail} />
                            </div>
                            <div className="text-danger">{errorEmail}&nbsp;</div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="mb-3">
                            <label className="form-label" htmlFor="basic-icon-default-preferredPronoun">Preferred Pronoun</label>
                            {/* <div className="input-group input-group-merge">
                                <span id="basic-icon-default-preferredPronoun" className="input-group-text"><i className="bx bx-bullseye"></i></span>
                                <input type="text" name="subjectPreferredPronoun" id="basic-icon-default-preferredPronoun" className="form-control phone-mask" placeholder="Preferred Pronoun" aria-label="Preferred Pronoun" aria-describedby="basic-icon-default-preferredPronoun" onChange={handleSubjectPPChange} onBlur={handleSubjectPPChange} value={formik.values.subjectPreferredPronoun} />
                            </div> */}
                            <Autocomplete
                                id="subjectPreferredPronoun"
                                sx={{ width: 'auto' }}
                                size='small'
                                options={[{value: 'her', name: 'Her'},{value: 'his', name: 'His'},{value: 'their', name: 'Their'}]}
                                getOptionLabel={(option) => option.name}
                                onChange={handleSubjectPPChange}
                                value={formik.values.subjectPreferredPronoun || null }
                                renderInput={(params) => <TextField {...params} label={"Preferred Pronoun"} />}
                            />
                            <div className="text-danger">{errorPP}&nbsp;</div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="mb-3">
                            <label className="form-label" htmlFor="basic-icon-default-subjectTitle">Title</label>

                            <div className="input-group input-group-merge">
                                <span id="basic-icon-default-subjectTitle" className="input-group-text" >
                                    <i className="bx bx-briefcase"></i>
                                </span>

                                <input
                                    type="text"
                                    name="subjectTitle"
                                    id="basic-icon-default-subjectTitle"
                                    className="form-control"
                                    placeholder="Title"
                                    aria-label="Title"
                                    onChange={(e) =>
                                        formik.setFieldValue('subjectTitle', e.target.value)
                                    }
                                    value={formik.values.subjectTitle}
                                />
                            </div>
                            <div className="text-danger">&nbsp;</div>
                        </div>
                    </div>
                    <div className="col-md-1 text-end">
                        <button type="button" className="btn btn-primary" onClick={addSubject}>Add</button>
                    </div>
                </div>
            </div>
            <div className="col-md-8 offset-md-2">
                <div className="row">
                    <table className="table table-striped mb-0">
                        <thead>
                            <tr>
                            <th scope="col">S. No.</th>
                            <th scope="col">First Name</th>
                            <th scope="col">Last Name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Preferred Pronoun</th>
                            <th scope="col">Title</th>
                            <th scope="col">Action</th>                                                
                            </tr>
                        </thead>
                        <tbody>
                            {formik.values.subjects.map((subject, sindex) => (
                                <tr key={sindex}>
                                    <th scope="row">{sindex + 1}</th>
                                    <td>{subject.firstName}</td>
                                    <td>{subject.lastName}</td>
                                    <td>{subject.email}</td>
                                    <td>{subject.preferredPronoun.replace(/\b[a-z]/g, function(letter) { return letter.toUpperCase(); })}</td>
                                    <td>{subject.title}</td>
                                    <td>                                                        
                                        <Tooltip title="Delete" size='small' className='icon icon-sm icon-primary' onClick={() => removeSubject(sindex)}>
                                            <IconButton>
                                                <Delete />
                                            </IconButton>
                                        </Tooltip>
                                    </td>                                               
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {formik.errors.subjects && (
                <div className="text-danger">{formik.errors.subjects}</div>
                 )}
            </div>
        </div>
        
    )
}